import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

interface LearnSidebarProps {
    currentPath: string;
    children?: React.ReactNode;
    hideDefaultCTA?: boolean;
}

const LearnSidebar: React.FC<LearnSidebarProps> = ({ currentPath, children, hideDefaultCTA = false }) => {
    const links = [
        { path: '/learn/what-is-ayurveda', label: '🌿 What Is Ayurveda?' },
        { path: '/learn/what-is-naturopathy', label: '🌱 What Is Naturopathy?' },
        { path: '/learn/what-is-acupressure', label: '🫧 What Is Acupressure?' },
        { path: '/learn/what-is-traditional-chinese-medicine', label: '☯️ What Is TCM?' },
        { path: '/learn/what-is-homeopathy', label: '💊 What Is Homeopathy?' },
        { path: '/learn/ancient-healing-traditions-compared', label: '🌍 All Five Compared' }
    ];

    return (
        <aside className="sticky top-20 w-full mb-8 lg:mb-0">
            {children}
            {/* Series Navigation Card */}
            <div className="bg-white border border-sage-100 rounded-2xl p-6 mb-6 shadow-sm">
                <h4 className="font-serif text-lg font-bold text-sage-900 mb-4">🌿 Healing Traditions Series</h4>
                <ul className="space-y-1">
                    {links.map((link) => {
                        const isCurrent = currentPath === link.path;
                        return (
                            <li key={link.path} className="border-b border-sage-50 last:border-0">
                                <Link
                                    to={link.path}
                                    className={`flex items-center gap-2 py-3 text-sm transition-colors ${isCurrent
                                            ? 'text-sage-700 font-bold'
                                            : 'text-sage-600 hover:text-sage-800'
                                        }`}
                                >
                                    {isCurrent && <span className="text-sage-500 mr-1">→</span>}
                                    {link.label}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </div>

            {/* Quick Reference - Optional slot could go here if passed as children */}

            {/* CTA Card */}
            {!hideDefaultCTA && (
                <div className="bg-gradient-to-br from-sage-800 to-[#1a3040] rounded-2xl p-6 text-center shadow-md">
                    <h4 className="font-serif text-white text-lg font-bold mb-3">Know Your Nature</h4>
                    <p className="text-white/80 text-sm mb-5 leading-relaxed">
                        Get personalised guidance drawing on all five ancient healing traditions — in one place.
                    </p>
                    <Link
                        to="/onboarding"
                        className="inline-flex items-center justify-center w-full px-4 py-3 bg-sage-500 text-white rounded-full font-bold text-sm hover:bg-sage-600 transition-colors shadow-sm"
                    >
                        Take the Wellness Assessment
                        <ArrowRight className="ml-1 w-4 h-4" />
                    </Link>
                </div>
            )}
        </aside>
    );
};

export default LearnSidebar;
